// Import axios library
import axios from 'axios';
import { getAuth, signOut } from 'firebase/auth';

const env = process.env.NODE_ENV
const devApiUrl = process.env.REACT_APP_PROXY_DEVELOPMENT;
const stgApiUrl = process.env.REACT_APP_PROXY_STG;
const prodApiUrl = process.env.REACT_APP_PROXY_PRODUCTION;
const auth = getAuth();

// Create an instance of axios with default settings
const api = axios.create({
    baseURL: (env == "development") ? devApiUrl : prodApiUrl, // Replace with your API base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

const addAuthHeader = async (config = {}) => {
    const idToken = await auth.currentUser?.getIdToken();
    const headers = {
        ...config.headers,
        Authorization: idToken ? `Bearer ${idToken}` : undefined
    };
    return { ...config, headers };
};

// Function to handle GET requests
export const get = async (url, params = {}, config = {}) => {
    try {
        const updatedConfig = await addAuthHeader({ params, ...config, withCredentials: true });
        const response = await api.get(url, updatedConfig);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const post = async (url, data = {}, config = {}) => {
    try {
        const updatedConfig = await addAuthHeader({ ...config, withCredentials: true });
        const response = await api.post(url, data, updatedConfig);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const put = async (url, data = {}, config = {}) => {
    try {
        const updatedConfig = await addAuthHeader({ ...config, withCredentials: true });
        const response = await api.put(url, data, updatedConfig);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const del = async (url, params = {}, config = {}) => {
    try {
        const updatedConfig = await addAuthHeader({ params, ...config, withCredentials: true });
        const response = await api.delete(url, updatedConfig);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const patch = async (url, data = {}, config = {}) => {
    try {
        const updatedConfig = await addAuthHeader({ ...config, withCredentials: true });
        const response = await api.patch(url, data, updatedConfig);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Error handling function
const handleError = (error) => {
    console.log(error)
    // Check if the error is a response error
    if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
            signOut(auth)
            window.location.reload();
            console.error('API Error 401:', data);
        } else if (status === 403) {
            window.location = '/'
            console.error('API Error 403:', data);
        } else {
            throw new Error(`API Error: ${status} ${error.response.statusText}`);
        }

    } else if (error.request) {
        console.error('Network Error:', error.request);
        throw new Error('Network Error');
    } else {
        console.error('Error:', error.message);
        throw new Error(`Error: ${error.message}`);
    }
};

export default api;
